(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bp-footer"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const storageKey = 'bp-welcome15-popup-v1';
    const dismissedFor = 7 * 24 * 60 * 60 * 1000;
    const subscribedFor = 180 * 24 * 60 * 60 * 1000;

    document.querySelectorAll('[data-bp-welcome-popup]').forEach((popup) => {
      if (popup.dataset.initialized === 'true') return;
      popup.dataset.initialized = 'true';

      const panel = popup.querySelector('.bp-welcome-popup__panel');
      const success = Boolean(popup.querySelector('[data-popup-success]'));
      const designMode = popup.dataset.designMode === 'true';
      let previousFocus = null;

      const readState = () => {
        try { return JSON.parse(localStorage.getItem(storageKey) || 'null'); } catch (_) { return null; }
      };
      const writeState = (duration, state) => {
        try { localStorage.setItem(storageKey, JSON.stringify({ state, until: Date.now() + duration })); } catch (_) {}
      };
      const open = () => {
        previousFocus = document.activeElement;
        popup.hidden = false;
        document.body.classList.add('bp-popup-open');
        requestAnimationFrame(() => {
          popup.classList.add('is-open');
          (popup.querySelector('input:not([type="hidden"])') || popup.querySelector('[data-popup-close]'))?.focus({ preventScroll: true });
        });
      };
      const close = (remember = true) => {
        popup.classList.remove('is-open');
        document.body.classList.remove('bp-popup-open');
        if (remember) writeState(success ? subscribedFor : dismissedFor, success ? 'subscribed' : 'dismissed');
        window.setTimeout(() => { popup.hidden = true; }, 270);
        previousFocus?.focus?.({ preventScroll: true });
      };

      popup.querySelectorAll('[data-popup-close]').forEach((button) => button.addEventListener('click', () => close(true)));
      popup.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') close(true);
        if (event.key !== 'Tab') return;
        const focusable = [...panel.querySelectorAll('button:not([disabled]), input:not([disabled]), a[href]')].filter((element) => element.offsetParent !== null);
        if (!focusable.length) return;
        const first = focusable[0];
        const last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
      });

      if (designMode || success) {
        open();
        if (success) writeState(subscribedFor, 'subscribed');
        return;
      }
      const saved = readState();
      if (saved?.until > Date.now()) return;
      window.setTimeout(open, Number(popup.dataset.delay) || 4500);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
